'use client';

import CivilServicesCityPage from './[city]/page';

export default function CivilPage() {
    return <CivilServicesCityPage />;
}
